import { Flex, Skeleton } from '@eqi-investimentos/react';
export const ConfirmSendOrderAdvisorSkeleton = () => <Flex flexDir="column" justify="space-between" h="full" gap="m" data-sentry-element="Flex" data-sentry-component="ConfirmSendOrderAdvisorSkeleton" data-sentry-source-file="Skeleton.tsx">
    <Flex flexDir="column" gap="m" data-sentry-element="Flex" data-sentry-source-file="Skeleton.tsx">
      <Skeleton w="full" h="30px" data-sentry-element="Skeleton" data-sentry-source-file="Skeleton.tsx" />
      <Flex flexDir="column" gap="m" data-sentry-element="Flex" data-sentry-source-file="Skeleton.tsx">
        {Array.from({
        length: 5
      }).map((_, index) => <Flex w="full" justify="space-between" key={index}>
            <Skeleton w="40px" h="30px" />
            <Skeleton w="140px" h="30px" />
          </Flex>)}
      </Flex>
    </Flex>
    <Flex gap="m" data-sentry-element="Flex" data-sentry-source-file="Skeleton.tsx">
      <Skeleton w="full" h="40px" data-sentry-element="Skeleton" data-sentry-source-file="Skeleton.tsx" />
      <Skeleton w="full" h="40px" data-sentry-element="Skeleton" data-sentry-source-file="Skeleton.tsx" />
    </Flex>
  </Flex>;